// SPDX-License-Identifier: AGPL-3.0-or-later

import RuntimeConfig from '@app/features/app/state/RuntimeConfig';
import {msg} from '@lingui/core/macro';
import {useLingui} from '@lingui/react/macro';
import {observer} from 'mobx-react-lite';
import type React from 'react';
import {getDataFlx, getImageSizingProps} from './BrandImageUtils';

const APPLICATION_ICON_DESCRIPTOR = msg({
	message: '{productName} application icon',
	comment: 'Accessible label for the Fluxer application icon.',
});
export const FluxerIcon = observer((props: React.SVGProps<SVGSVGElement>) => {
	const {i18n} = useLingui();
	const ariaLabel = i18n._(APPLICATION_ICON_DESCRIPTOR, {productName: RuntimeConfig.productName});
	if (RuntimeConfig.iconUrl) {
		return (
			<img
				{...getImageSizingProps(props)}
				src={RuntimeConfig.iconUrl}
				alt={ariaLabel}
				data-flx={getDataFlx(props, 'ui.icons.fluxer-icon.img')}
			/>
		);
	}
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 512 512"
			role="img"
			aria-label={ariaLabel}
			data-flx="ui.icons.fluxer-icon.img"
			{...props}
		>
			<rect fill="var(--brand-primary)" height={512} rx={256} width={512} data-flx="ui.icons.fluxer-icon.rect" />
			<path
				fill="var(--brand-primary-fill)"
				d="M 243.9,50.9 C 229.3,56.3 228.2,57.5 194.4,115.1 C 183.5,134 152.3,187.2 125.4,233.1 C 98.4,279.1 65.7,334.9 52.6,357.3 C 39.6,379.5 27.3,401.3 25.3,405.6 C 17.2,424.1 28.7,449.9 49.6,459.6 L 58.5,463.9 L 137.7,463.9 L 217.1,463.9 L 219.8,458.9 C 221.4,456.3 233.9,435 247.4,411.7 C 261.2,388.3 272.8,367.9 273.5,366.3 C 274.6,363.6 269.8,363.5 221.5,363.5 C 192.3,363.5 168.5,363.1 168.5,362.8 C 168.5,362.2 180,342.5 193.9,318.7 C 208,295 230.2,256.7 243.6,233.7 C 256.8,210.6 277,175.9 288.3,156.5 C 299.7,137.2 310.3,118.8 311.9,115.7 L 314.7,110 L 301.3,87.1 C 280.5,51.2 266.6,42.6 243.9,50.9 M 326.5,141.9 C 323,147.7 298,189.8 283.2,215.2 L 270.5,236.8 L 304.3,294.4 C 322.8,326.1 339.5,354.7 341.5,357.7 L 345,363.5 L 324.9,363.5 L 305,363.5 L 276.5,412.6 C 260.6,439.6 247.8,462.1 247.8,462.8 C 247.8,464.7 450.7,464 457.7,462.1 C 482,455.2 496.5,423.7 485.4,401.9 C 481.1,393.6 402.8,259.4 364.9,195.3 C 351.2,172 338,149.7 335.7,145.6 C 330.7,137 329.9,136.6 326.5,141.9"
				data-flx="ui.icons.fluxer-icon.path"
			/>
		</svg>
	);
});
